import { Box, Card, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Tabs, Tab, InputAdornment, Button } from '@mui/material';
import LayoutAccessManagement from 'components/structure/LayoutAccessManagement';
import { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomBlueCheckbox from 'utils/CustomBlueCheckbox';
import { AuthData } from 'auth/AuthWarpper';
import UserFunctionalityService from 'services/UserFunctionalityService';
import { SnackbarContext } from 'context/snackBarContext';

const RoleAssign = () => {
    const { setOpenAlert, setSeverity, setMessage } =
        useContext(SnackbarContext);
    const { user } = AuthData();
    const navigate = useNavigate();
    const location = useLocation();
    const { rowData, functionalities, nonPrivilegedFunctionalities, mainContentItems } = location.state || {};
    console.log('location.state', location.state);

    const columns = [
        { id: 'functionality', label: 'Functionality' },
        { id: 'subFunctionality', label: 'Sub Functionality' },
        { id: 'create', label: 'Create' },
        { id: 'read', label: 'Read' },
        { id: 'update', label: 'Update' },
        { id: 'delete', label: 'Delete' },
    ];

    // Function to find functionality name by key
    const getFunctionalityName = (key) => {
        const findInTree = (items) => {
            for (const item of items) {
                if (item.children) {
                    for (const child of item.children) {
                        if (child.key === key) return child.name;
                        if (child.children) {
                            const found = child.children.find(c => c.key === key);
                            if (found) return child.name;
                        }
                    }
                }
            }
            return '';
        };

        return findInTree([...functionalities, ...nonPrivilegedFunctionalities]);
    };

    // Function to check if a key belongs to MVP 02(ESG)
    const belongsToMVP02ESG = (key) => {
        const checkInTree = (items) => {
            for (const item of items) {
                if (item.key === "mvp 02(esg)") {
                    // Check if the key exists in any child of this MVP 02(ESG) item
                    const findInChildren = (children) => {
                        for (const child of children) {
                            if (child.key === key) return true;
                            if (child.children) {
                                const found = child.children.some(c => c.key === key);
                                if (found) return true;
                            }
                        }
                        return false;
                    };
                    return item.children ? findInChildren(item.children) : false;
                }
                if (item.children) {
                    const found = checkInTree(item.children);
                    if (found) return true;
                }
            }
            return false;
        };

        return checkInTree([...functionalities, ...nonPrivilegedFunctionalities]);
    };

    // Transform mainContentItems into table data structure
    const transformData = () => {
        const tableData = [];
        mainContentItems?.forEach(item => {
            // Skip if the item belongs to MVP 02(ESG)
            // if (belongsToMVP02ESG(item.key)) {
            //     return;
            // }

            // Find matching functionality in rowData
            const existingFunctionality = location?.state?.rowData?.functionalities?.find(
                f => f.functionality_id === item.key
            );

            const functionalityName = getFunctionalityName(item.key);
            
            // Get CRUD values from existingFunctionality if present, else use false
            const isCreate = existingFunctionality?.isCreate || false;
            const isUpdate = existingFunctionality?.isUpdate || false;
            const isDelete = existingFunctionality?.isDelete || false;
            const isRead = existingFunctionality ? 
                (existingFunctionality.isCreate || 
                 existingFunctionality.isUpdate || 
                 existingFunctionality.isDelete || 
                 existingFunctionality.isRead) : false;

            tableData.push({
                functionality: functionalityName,
                subFunctionality: item.name,
                key: item.key,
                isCreate: isCreate,
                isRead: isRead,
                isUpdate: isUpdate,
                isDelete: isDelete,
                isWebFunctionality: existingFunctionality?.isWebFunctionality || item.isWebFunctionality || false,
                isReadOnly: item.isReadOnly || false
            });
        });
        return tableData;
    };

    const [tableData, setTableData] = useState(transformData());

    const handleToggle = (index, permission) => {
        const newData = [...tableData];
        const row = newData[index];

        if (permission === 'isRead') {
            // If any other permission is true, Read cannot be unchecked
            if (row.isCreate || row.isUpdate || row.isDelete) {
                return;
            }
            row.isRead = !row.isRead;
        } else {
            row[permission] = !row[permission];
            // If any permission becomes true, Read should also be true
            if (row[permission]) {
                row.isRead = true;
            }
        }

        setTableData(newData);
    };

    const VerticalLine = () => {
        return (
            < Box
                sx={{
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#0E2B63',
                    opacity: 0.2,
                    margin: '0 auto'
                }}
            />
        );
    };
    // Add this function to transform table data into API format
    const transformTableData = (tableData) => {
        return tableData.map(row => {
            // Find matching functionality in rowData
            const existingFunctionality = location?.state?.rowData?.functionalities?.find(
                f => f.functionality_id === row.key
            );

            return {
                // Use existing role_functionality_link_id if found
                role_functionality_link_id: existingFunctionality?.role_functionality_link_id || "",
                functionality_id: row.key,
                functionality_name: row.subFunctionality,
                isCreate: row.isCreate,
                isUpdate: row.isUpdate,
                isRead: row.isRead,
                isDelete: row.isDelete,
                isReadOnly: row.isReadOnly || false,
                isWebFunctionality: row.isWebFunctionality || false
            };
        });
    };

    const onUpdate = () => {
        let roleId = ''
        if (location?.state?.fromUrl == '/administratorCreation' || location?.state?.fromUrl == 'roleCreation') {
            roleId = location?.state?.rowData['profileId']
        } else {
            roleId = location?.state?.rowData['role_id']
        }
        let data =
        {
            createdByUser: user?.userName,
            modifiedByUser: user?.userName,
            role_id: roleId,
            functionalities: transformTableData(tableData)
        }

        UserFunctionalityService.PostUserFunctionalityMapModules(data).then((res) => {
            let data = res?.data?.response
            setSeverity("success");
            setMessage("Assigned Successfully");
            setOpenAlert(true);
            navigate(location?.state?.fromUrl, { state: { rowData: data } })
        }).catch((error) => {
            setSeverity("error");
            setMessage(error?.response?.data?.message || error?.message);
            setOpenAlert(true);
            console.log(error)
        })

    }
    return (
        <LayoutAccessManagement title="Access Management">
            <Card
                className='Access-Management-Layout'
                sx={{
                    backgroundColor: "#f3f5f8",
                    color: "white",
                    marginBottom: "30px",
                    padding: "20px",
                    border: "none",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <Box sx={{ width: "80%", marginTop: "40px", marginBottom: "40px", borderRadius: '16px', backgroundColor: "#fff", height: "auto" }}>
                    <Box className="roleAssignHeader">
                        {rowData?.role_name}
                    </Box>
                    <VerticalLine />
                    <Box className="roleAssignHeader2" sx={{ fontWeight: 700, padding: '23px 0px 20px 0px' }}>
                        Role Owner
                        <Box className="roleAssignHeader2" sx={{ fontWeight: 500 }}>{rowData?.role_owner?.profile_owner_name}</Box>
                    </Box>
                    <VerticalLine />
                    <Box className="roleAssignHeader2" sx={{ fontWeight: 700, padding: '20px 0px 17px 0px' }}>Assigned Functionality</Box>
                    <Box className="roleAssignTable">
                        <TableContainer
                            component={Paper}
                            sx={{
                                height: '395px',
                                overflowY: 'hidden', // Hide the outer scrollbar
                                overflowX: 'hidden', // Hide the outer scrollbar

                                '& .MuiTable-root': {
                                    '& thead': {
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 1,
                                        backgroundColor: '#102A63',
                                        width: 'calc(100% - 8px)', // Adjust for scrollbar width
                                    },
                                    '& tbody': {
                                        display: 'block',
                                        height: '325px',
                                        overflowY: 'scroll', // Show scrollbar only in tbody
                                        '&::-webkit-scrollbar': {
                                            width: '4px',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: '#D9D9D9',
                                            borderRadius: '4px'
                                        }
                                    },
                                    '& thead tr': {
                                        display: 'table',
                                        width: '100%',
                                        tableLayout: 'fixed',
                                    },
                                    '& tbody tr': {
                                        display: 'table',
                                        width: '100%',
                                        tableLayout: 'fixed'
                                    }
                                }
                            }}
                        >
                            <Table>
                                <TableHead sx={{ backgroundColor: '#102A63' }}>
                                    <TableRow >
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                sx={{
                                                    color: '#fff',
                                                    borderRight: '1px solid #ddd',
                                                    textAlign: "center"
                                                }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.map((row, index) => (
                                        <TableRow key={row.key}>
                                            <TableCell sx={{
                                                borderRight: '1px solid #ddd',
                                                maxWidth: 200,
                                            }}>
                                                {row.functionality}
                                            </TableCell>
                                            <TableCell sx={{
                                                borderRight: '1px solid #ddd',
                                                maxWidth: 200,
                                            }}>
                                                {row.subFunctionality}
                                            </TableCell>
                                            <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                <CustomBlueCheckbox
                                                    checked={row.isCreate}
                                                    onClick={() => handleToggle(index, 'isCreate')}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                <CustomBlueCheckbox
                                                    checked={row.isRead}
                                                    onClick={() => handleToggle(index, 'isRead')}
                                                    disabled={row.isCreate || row.isUpdate || row.isDelete}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                <CustomBlueCheckbox
                                                    checked={row.isUpdate}
                                                    onClick={() => handleToggle(index, 'isUpdate')}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                                <CustomBlueCheckbox
                                                    checked={row.isDelete}
                                                    onClick={() => handleToggle(index, 'isDelete')}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box sx={{ paddingTop: "30px" }}>
                        <VerticalLine />
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "cemter", margin: "40px 10px" }}>
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 130,
                                minHeight: 54,
                                background: "#737D86",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#737D86",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={(e) => navigate(-1)}
                        >
                            {"BACK"}
                        </Button>
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 156,
                                minHeight: 54,
                                background: "#EF7D00",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#EF7D00",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={onUpdate}  // Changed this line
                        >
                            {"SUBMIT"}
                        </Button>
                    </Box>
                </Box>
            </Card>
        </LayoutAccessManagement >
    );
};

export default RoleAssign;
